import script from "./GroupsStep.vue?vue&type=script&setup=true&lang=js"
export * from "./GroupsStep.vue?vue&type=script&setup=true&lang=js"

import "./GroupsStep.vue?vue&type=style&index=0&id=1d351e84&lang=scss&scoped=true"

import exportComponent from "../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-1d351e84"]])

export default __exports__